import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPromptTemplates } from '../selectors/promptTemplateSelectors';
import { refetchAndFormatFeaturedTemplates } from '../slices/promptTemplates';
export const useRefetchFeaturedTemplates = () => {
  const templates = useSelector(selectPromptTemplates);
  const dispatch = useDispatch();
  return useCallback(newPathName => {
    dispatch(refetchAndFormatFeaturedTemplates({
      pathname: newPathName,
      templates
    })).catch(e => {
      consoleIfNotProd.error('Error re-fetching prompt templates', e);
    });
  }, [dispatch, templates]);
};